// AddWebsite.js - สำหรับ Affiliator เพิ่มเว็บไซต์ของตัวเอง แบบแนบ owner

import React, { useState } from 'react';
import { jwtDecode } from 'jwt-decode';

const AddWebsite = () => {
    const [websiteName, setWebsiteName] = useState('');
    const [websiteUrl, setWebsiteUrl] = useState('');
    const [message, setMessage] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("access_token");
        if (!token) return setMessage("🔐 กรุณาเข้าสู่ระบบก่อนเพิ่มเว็บไซต์");

        let owner = "unknown";
        try {
            const decoded = jwtDecode(token);
            owner = decoded.preferred_username || decoded.email || "unknown";
        } catch (err) {
            console.error("Token decode error", err);
        }

        const res = await fetch("https://affiliate-project.onrender.com/api/register-website", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                websiteName,
                websiteUrl,
                owner
            })
        });

        if (res.ok) {
            setMessage("✅ เพิ่มเว็บไซต์เรียบร้อยแล้ว");
            setWebsiteName('');
            setWebsiteUrl('');
        } else {
            const text = await res.text();
            setMessage("❌ เพิ่มเว็บไซต์ไม่สำเร็จ: " + text);
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center mt-5" style={{ minHeight: '80vh'}}>
            <div className="card p-4" style={{ width: '100%', maxWidth: '500px', borderRadius: '10px', border: '1px solid #ddd', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                <h2 className="text-center mb-4">🌐 เพิ่มเว็บไซต์ของคุณ</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label">ชื่อเว็บไซต์</label>
                        <input
                            type="text"
                            className="form-control"
                            value={websiteName}
                            onChange={(e) => setWebsiteName(e.target.value)}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">URL เว็บไซต์</label>
                        <input
                            type="url"
                            className="form-control"
                            value={websiteUrl}
                            onChange={(e) => setWebsiteUrl(e.target.value)}
                            required
                        />
                    </div>

                    <button type="submit" className="btn btn-primary w-100">
                        ➕ เพิ่มเว็บไซต์
                    </button>
                </form>
                {message && <div className="alert alert-info mt-3">{message}</div>}
            </div>
        </div>

    );
};

export default AddWebsite;
